import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default {
  namespaced: true,
  state: {
    associatedField: {
      companyList: [],
    },
    filterData: {
      selectedCompany: [],
    },
    appliedFilter: {},
    deletedContactToggle : false
  },
  mutations: {
    associatedField: (state, data) => {
      state.associatedField = data;
    },
    companyList: (state, data) => {
      state.associatedField.companyList = data;
    },
    filterData: (state, data) => {
      state.filterData = data;
    },
    appliedFilter: (state, data) => {
      state.appliedFilter = data;
    },
    deletedContactToggle: (state, data) => {
      state.deletedContactToggle = data
    }
  },
  actions: {
    associatedField({ commit }, [data]) {
      commit("associatedField", data);
    },
    companyList({ commit }, [data]) {
      commit("companyList", data);
    },
    filterData({ commit }, [data]) {
      commit("filterData", data);
    },
    appliedFilter({ commit }, [data]) {
      commit("appliedFilter", data);
    },
    deletedContactToggle({commit} , [data]){
      commit("deletedContactToggle" , data)
    }
  },
  getters: {
    associatedField: (state) => state.associatedField,
    companyList: (state) => state.associatedField.companyList,
    filterData: (state) => state.filterData,
    appliedFilter: (state) => state.appliedFilter,
    getdeletedContactToggle: (state) => state.deletedContactToggle
  },
};
